import React from "react";
import { Link } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "./ui/dropdown-menu";
import { ArrowRight, MessageCircle, Calendar, Smartphone } from "lucide-react";
import { SITE, bookingHref, smsHref } from "../lib/site";

export default function BookingButton({
  variant = "primary",
  testid = "booking-cta",
  children,
  className = "",
}) {
  const cls = variant === "primary" ? "btn-primary" : "btn-outline";
  const hasWhatsApp = !SITE.bookingUrl?.trim() && !!SITE.whatsappNumber?.trim();
  const hasSms = !!smsHref();
  const hasExternalBooking = !!SITE.bookingUrl?.trim();
  const label = children || "Réserver une séance";

  // Case 1: external booking URL is set → single direct link
  if (hasExternalBooking) {
    return (
      <a
        href={SITE.bookingUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        className={`${cls} ${className}`}
      >
        <Calendar size={16} /> {label} <ArrowRight size={16} />
      </a>
    );
  }

  // Case 2: WhatsApp + SMS → dropdown with two choices
  if (hasWhatsApp && hasSms) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button data-testid={testid} className={`${cls} ${className}`}>
            <Calendar size={16} /> {label} <ArrowRight size={16} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="center" className="w-72 rounded-xl">
          <DropdownMenuLabel className="font-serif text-sand-700 text-sm">
            Comment souhaitez-vous m'écrire&nbsp;?
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <a
              href={bookingHref()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`${testid}-whatsapp`}
              className="flex items-center gap-3 py-3 cursor-pointer"
            >
              <MessageCircle size={18} className="text-emerald-600" />
              <div>
                <p className="font-medium text-sand-900">WhatsApp</p>
                <p className="text-xs text-sand-600">Message instantané</p>
              </div>
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a
              href={smsHref()}
              data-testid={`${testid}-sms`}
              className="flex items-center gap-3 py-3 cursor-pointer"
            >
              <Smartphone size={18} className="text-sand-700" />
              <div>
                <p className="font-medium text-sand-900">SMS</p>
                <p className="text-xs text-sand-600">Texto classique</p>
              </div>
            </a>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  // Case 3: WhatsApp only
  if (hasWhatsApp) {
    return (
      <a
        href={bookingHref()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        className={`${cls} ${className}`}
      >
        <MessageCircle size={16} /> {label} <ArrowRight size={16} />
      </a>
    );
  }

  // Fallback: redirect to /reserver
  return (
    <Link to="/reserver" data-testid={testid} className={`${cls} ${className}`}>
      <Calendar size={16} /> {label} <ArrowRight size={16} />
    </Link>
  );
}
